export default {"src":"/login-app/[GIT_HASH]/_next/static/media/magnify_glass.7eb53a2f.svg","height":10,"width":14,"blurWidth":0,"blurHeight":0};